module.exports = __webpack_public_path__ + "img/reco1.3a34b944.jpg";